import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import ContentLayout from '../../components/ContentLayout'
import { loadingActions } from '../../actions/loadingActions'
import style from './Homepage.module.scss'
import { Alert, Button, Col, Form, Row } from 'react-bootstrap'
import { formService } from '../../services/formService'
import { useDispatch, useSelector } from 'react-redux'
import { authActions } from '../../actions/authActions'
import PhotoUploader from '../../components/PhotoUploader/PhotoUploader'
import getpaises from '../../assets/combos/getpaises.json'
import getposicoes from '../../assets/combos/getposicoes.json'
import getsubposicoes from '../../assets/combos/getsubposicoes.json'
import getpes from '../../assets/combos/getpes.json'
import getmodalidades from '../../assets/combos/getmodalidades.json'

const Homepage = () => {
  const dispatch = useDispatch()
  const { formatMessage: f } = useIntl()
  const [errorMessage, setErrorMessage] = useState('')
  const [availableCountries, setAvailableCountries] = useState([])
  const [availablePositions, setAvailablePositions] = useState([])
  const [availableSubPositions, setAvailableSubPositions] = useState([])
  const [availableSubPositions2, setAvailableSubPositions2] = useState([])
  const [availableFeet, setAvailableFeet] = useState([])
  const [availableSports, setAvailableSports] = useState([])
  const [allPositions, setAllPositions] = useState([]);
  const [allSubPositions, setAllSubPositions] = useState([]);
  const player = useSelector(state => state.auth.player)
  const hash = useSelector(state => state.auth.hash)
  const [thumbnail, setThumbnail] = useState('')
  const [showPhotoUploader, setShowPhotoUploader] = useState(false)
  const [savedMsg, setSavedMsg] = useState('')
  const makeRequests = false
  const [playerFormData, setPlayerFormData] = useState(
    {
      'NAME': '',
      'SHORT_NAME': '',
      'FK_COUNTRY': '',
      'FK_COUNTRY_ORIGEM': '',
      'NATURALIDADE': '',
      'BIRTHDAY': '',
      'TE_MODALIDADE': '',
      'POSITION_ID': '',
      'POSITION2_ID': '',
      'SUBPOSITION_ID': '',
      'SUBPOSITION2_ID': '',
      'HEIGHT': '',
      'WEIGHT': '',
      'STRONG_FOOT': '',
      'TWITTER': '',
      'FACEBOOK': '',
      'YOUTUBE': '',
      'INSTAGRAM': '',
      'LINKEDIN': '',
      'IMGPATH': '',
      'MODALIDADE_MAE': '',
      'OBS': '',
    }
  )

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const hash = searchParams.get('h')

    dispatch(authActions.checkHash(hash, setErrorMessage))
  }, [dispatch])

  useEffect(() => {
    if (player) {
      setPlayerFormData({
        'NAME': player.NAME,
        'SHORT_NAME': player.SHORT_NAME,
        'FK_COUNTRY': player.FK_COUNTRY,
        'FK_COUNTRY_ORIGEM': player.FK_COUNTRY_ORIGEM,
        'NATURALIDADE': player.NATURALIDADE,
        'BIRTHDAY': player.BIRTHDAY,
        'TE_MODALIDADE': player.TE_MODALIDADE,
        'POSITION_ID': player.POSITION_ID,
        'POSITION2_ID': player.POSITION2_ID,
        'SUBPOSITION_ID': player.SUBPOSITION_ID,
        'SUBPOSITION2_ID': player.SUBPOSITION2_ID,
        'HEIGHT': player.HEIGHT,
        'WEIGHT': player.WEIGHT,
        'STRONG_FOOT': player.STRONG_FOOT,
        'TWITTER': player.TWITTER,
        'FACEBOOK': player.FACEBOOK,
        'INSTAGRAM': player.INSTAGRAM,
        'LINKEDIN': player.LINKEDIN,
        'YOUTUBE': player.YOUTUBE,
        'IMGPATH': player.IMGPATH,
        'OBS': ''
      })

      setThumbnail(player.IMGPATH != '' && player.IMGPATH != null && player.IMGPATH != undefined ? `https://www.zerozero.pt/img/jogadores/${player.IMGPATH}` : 'https://www.zerozero.pt/images/dsgn/nophoto.gif')

      if (makeRequests) {
        formService
          .getPaises()
          .then((res) => {
            dispatch(loadingActions.removeRequest())
            setAvailableCountries(res)
          })
          .catch((error) => { })

        formService
          .getPosicoes()
          .then((res) => {
            dispatch(loadingActions.removeRequest())
            const positions = res;
            setAllPositions(positions)
            const available = positions.filter((pos) => {
              return pos.te_modalidade === (player.TE_MODALIDADE_MAE != 0 ? player.TE_MODALIDADE_MAE : player.TE_MODALIDADE);
            })
            setAvailablePositions(available)
          })
          .catch((error) => { })

        formService
          .getSubPosicoes()
          .then((res) => {
            dispatch(loadingActions.removeRequest())
            const positions = res;
            setAllSubPositions(positions)
            const available = positions.filter((pos) => {
              return pos.tipo_posicao === player.POSITION_ID;
            })
            setAvailableSubPositions(available)
            const available2 = positions.filter((pos) => {
              return pos.tipo_posicao === player.POSITION2_ID;
            })
            setAvailableSubPositions2(available2)
          })
          .catch((error) => { })

        formService
          .getPes()
          .then((res) => {
            dispatch(loadingActions.removeRequest())
            setAvailableFeet(res)
          })
          .catch((error) => { })

        formService
          .getModalidades()
          .then((res) => {
            dispatch(loadingActions.removeRequest())
            setAvailableSports(res)
          })
          .catch((error) => { })
      }
      else {
        setAvailableCountries(getpaises.data)
        setAvailableFeet(getpes.data)
        setAvailableSports(getmodalidades.data)
        const positions = getposicoes.data;
        setAllPositions(positions)
        const available = positions.filter((pos) => {
          return pos.te_modalidade === (player.TE_MODALIDADE_MAE != 0 ? player.TE_MODALIDADE_MAE : player.TE_MODALIDADE);
        })
        console.log(player.TE_MODALIDADE_MAE);
        setAvailablePositions(available)
        const subpositions = getsubposicoes.data;
        setAllSubPositions(subpositions)
        const availableSub = subpositions.filter((pos) => {
          return pos.tipo_posicao === player.POSITION_ID;
        })
        setAvailableSubPositions(availableSub)
        const available2 = subpositions.filter((pos) => {
          return pos.tipo_posicao === player.POSITION2_ID;
        })
        setAvailableSubPositions2(available2)
      }
    }
  }, [dispatch, player, makeRequests])

  const onChangePlayerForm = (value, type) => {
    setPlayerFormData((prevState) => ({
      ...prevState,
      [type]: value
    }))

    if (type === "TE_MODALIDADE") {
      // Clear positions and subpositions
      setPlayerFormData((prevState) => ({
        ...prevState,
        'POSITION_ID': 0,
        'POSITION2_ID': 0,
        'SUBPOSITION_ID': 0,
        'SUBPOSITION2_ID': 0,
      }))

      // Set available positions
      const modalidadeLines = availableSports.filter((mod) => { return mod.id === value; })
      const modalidadeMae = modalidadeLines.length > 0 && modalidadeLines[0].modalidade_mae !== '0' ? modalidadeLines[0].modalidade_mae : value
      const availablePos = allPositions.filter((pos) => {
        return pos.te_modalidade === modalidadeMae;
      })
      setAvailablePositions(availablePos)
      // Set available subpositions
      const availablePositionsIds = availablePos.map((pos) => pos.id)
      const availableSubPos = allSubPositions.filter((pos) => {
        return availablePositionsIds.includes(pos.tipo_posicao);
      })
      setAvailableSubPositions(availableSubPos)
      const availableSubPos2 = allSubPositions.filter((pos) => {
        return availablePositionsIds.includes(pos.tipo_posicao);
      })
      setAvailableSubPositions2(availableSubPos2)
    }
    else if (type === "POSITION_ID") {
      // Clear subposition
      setPlayerFormData((prevState) => ({
        ...prevState,
        'SUBPOSITION_ID': 0,
      }))

      // Set available subpositions
      const availableSubPos = allSubPositions.filter((pos) => {
        return pos.tipo_posicao === value;
      })
      setAvailableSubPositions(availableSubPos)
    }
    else if (type === "POSITION2_ID") {
      // Clear subposition
      setPlayerFormData((prevState) => ({
        ...prevState,
        'SUBPOSITION2_ID': 0,
      }))

      // Set available subpositions
      const availableSubPos = allSubPositions.filter((pos) => {
        return pos.tipo_posicao === value;
      })
      setAvailableSubPositions2(availableSubPos)
    }
  }

  const saveForm = (event) => {
    event.preventDefault();

    formService.saveForm({
      'name': playerFormData.NAME,
      'short_name': playerFormData.SHORT_NAME,
      'fk_country': playerFormData.FK_COUNTRY,
      'fk_country_origem': playerFormData.FK_COUNTRY_ORIGEM,
      'naturalidade': playerFormData.NATURALIDADE,
      'birthday': playerFormData.BIRTHDAY,
      'te_modalidade': playerFormData.TE_MODALIDADE,
      'position_id': playerFormData.POSITION_ID,
      'position2_id': playerFormData.POSITION2_ID,
      'subposition_id': playerFormData.SUBPOSITION_ID,
      'subposition2_id': playerFormData.SUBPOSITION2_ID,
      'height': playerFormData.HEIGHT,
      'weight': playerFormData.WEIGHT,
      'strong_foot': playerFormData.STRONG_FOOT,
      'twitter': playerFormData.TWITTER,
      'facebook': playerFormData.FACEBOOK,
      'instagram': playerFormData.INSTAGRAM,
      'linkedin': playerFormData.LINKEDIN,
      'youtube': playerFormData.YOUTUBE,
      'imgpath': thumbnail,
      'obs': playerFormData.OBS
    }, hash).then((res) => {
      setSavedMsg('Os dados do jogador foram guardados com sucesso. Obrigado!')
    }).catch((error) => { });
  }

  return (
    <ContentLayout>
      <div className={style.header}>
        {player && (
          <a target='_blank' rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", color: "#3e5368", fontSize: "22px", fontWeight: "bold", marginLeft: "20px" }} href={player.URL}>
            {player.IMGPATH && (<img src={thumbnail} alt='' />)}
            {player.NAME && (<p className='mb-0 ml-4'>{player.SHORT_NAME}</p>)}
          </a>
        )}
        {(!player || !player.NAME) && (<p>{f({ id: 'homepage.form' })}</p>)}
      </div>
      <div className={style.mainContentWrapper}>
        {errorMessage}
        {!errorMessage && player && (
          <Form style={{ width: "100%" }} onSubmit={saveForm}>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">
                {showPhotoUploader && (
                  <PhotoUploader
                    showPhotoUploader={showPhotoUploader}
                    setShowPhotoUploader={setShowPhotoUploader}
                    playerId={player.ID}
                    handleCloseForm={() => { }}
                    setPhotoThumbnail={setThumbnail}
                  />
                )}
                <div className={style.photoUpload} onClick={() => setShowPhotoUploader(true)}>
                  <div>+</div>
                  <img width={140} style={{ cursor: "pointer" }} src={thumbnail} alt='' />
                </div>
              </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Nome completo</Form.Label>
              <Col md="6">
                <Form.Control required onChange={(event) => onChangePlayerForm(event.target.value, 'NAME')} id='completeName' type="text" value={playerFormData.NAME} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Nome curto</Form.Label>
              <Col md="6">
                <Form.Control required onChange={(event) => onChangePlayerForm(event.target.value, 'SHORT_NAME')} id='shortName' type="text" value={playerFormData.SHORT_NAME} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Nacionalidade</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'FK_COUNTRY')} id='country' as='select' value={playerFormData.FK_COUNTRY}>
                  <option>Escolher país</option>
                  {availableCountries && availableCountries.map(country => {
                    return (
                      <option key={'country_' + country.id} value={country.id}>{country.nome}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">País de origem</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'FK_COUNTRY_ORIGEM')} id='country' as='select' value={playerFormData.FK_COUNTRY_ORIGEM}>
                  <option>Escolher país</option>
                  {availableCountries && availableCountries.map(country => {
                    return (
                      <option key={'country_' + country.id} value={country.id}>{country.nome}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Naturalidade</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'NATURALIDADE')} id='naturality' type="text" value={playerFormData.NATURALIDADE} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Data de nascimento</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'BIRTHDAY')} id='date' type="date" value={playerFormData.BIRTHDAY} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Twitter</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'TWITTER')} id='twitter' type="text" value={playerFormData.TWITTER} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Facebook</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'FACEBOOK')} id='facebook' type="text" value={playerFormData.FACEBOOK} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Youtube</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'YOUTUBE')} id='youtube' type="text" value={playerFormData.YOUTUBE} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Instagram</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'INSTAGRAM')} id='instagram' type="text" value={playerFormData.INSTAGRAM} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">LinkedIn</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'LINKEDIN')} id='linkedin' type="text" value={playerFormData.LINKEDIN} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Modalidade</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'TE_MODALIDADE')} id='sports' as='select' value={playerFormData.TE_MODALIDADE}>
                  <option>Escolher modalidade</option>
                  {availableSports && availableSports.map(sports => {
                    return (
                      <option key={'sports_' + sports.id} value={sports.id}>{sports.descr}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Posição</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'POSITION_ID')} id='position' as='select' value={playerFormData.POSITION_ID}>
                  <option>Escolher posição</option>
                  {availablePositions && availablePositions.map(position => {
                    return (
                      <option key={'position_' + position.id} value={position.id}>{position.descr}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Sub Posição</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'SUBPOSITION_ID')} id='subposition' as='select' value={playerFormData.SUBPOSITION_ID}>
                  <option>Escolher subposição</option>
                  {availableSubPositions && availableSubPositions.map(subposition => {
                    return (
                      <option key={'subposition_' + subposition.id} value={subposition.id}>{subposition.descr}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">2ª Posição</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'POSITION2_ID')} id='second_position' as='select' value={playerFormData.POSITION2_ID}>
                  <option>Escolher posição</option>
                  {availablePositions && availablePositions.map(position => {
                    return (
                      <option key={'position_' + position.id} value={position.id}>{position.descr}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">2ª Sub Posição</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'SUBPOSITION2_ID')} id='subposition' as='select' value={playerFormData.SUBPOSITION2_ID}>
                  <option>Escolher subposição</option>
                  {availableSubPositions2 && availableSubPositions2.map(subposition => {
                    return (
                      <option key={'subposition_' + subposition.id} value={subposition.id}>{subposition.descr}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Pé preferencial</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'STRONG_FOOT')} id='foot' as='select' value={playerFormData.STRONG_FOOT}>
                  <option>Escolher pé preferencial</option>
                  {availableFeet && availableFeet.map(foot => {
                    return (
                      <option key={'foot_' + foot.id} value={foot.id}>{foot.descr}</option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Altura (cm)</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'HEIGHT')} id='height' type="number" value={playerFormData.HEIGHT} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Peso (kg)</Form.Label>
              <Col md="6">
                <Form.Control onChange={(event) => onChangePlayerForm(event.target.value, 'WEIGHT')} id='weight' type="number" value={playerFormData.WEIGHT} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column md="2">Observações</Form.Label>
              <Col md="6">
                <Form.Control as='textarea' rows={3} onChange={(event) => onChangePlayerForm(event.target.value, 'OBS')} id='obs' type="text" value={playerFormData.OBS} />
              </Col>
            </Form.Group>
            <Row className='mt-5'>
              <Col md="8" className='d-flex' style={{ alignItems: "center" }}>
                {savedMsg && (
                <Alert className='m-0' key={'success'} variant={'success'}>
                  {savedMsg}
                </Alert>
                )}
                <Button onClick={() => window.location.reload()} style={{height: "min-content", backgroundColor: "#9e9e9e", borderColor: "#9e9e9e"}} className='ml-auto'>Reverter</Button>
                <Button onClick={() => setSavedMsg('')} style={{height: "min-content"}} className='ml-4' type='submit' color='primary'>Guardar</Button>
              </Col>
            </Row>
          </Form>
        )}
      </div>
    </ContentLayout>
  )
}

export default Homepage
